<template>
    <div class="mt-15">
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else-if="bloqueo==1">
            <v-container>
                <v-row>
                <v-col cols="12" md="2"></v-col>  
                <v-col cols="12" md="8" class="text-center mt-5">
                    <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="12" class="d-flex">
                                    <h5 class="mt-1">Selecciona Tipo Reporte</h5>
                                </v-col>
                            </v-row>
                            <v-row class="mt-10">
                                <v-col cols="12" md="4" class="mt-n7">
                                    <v-select @change="change_tipo()" class='text-caption' v-model="tipo" :items="tipos" label="Reporte" dense outlined rounded></v-select>
                                </v-col>
                                <v-col cols="12" md="4" class="mt-n7">
                                    <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="date1" label="Desde" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined rounded></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="4" class="mt-n7">
                                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="date2" label="Hasta" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined rounded></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="12" class="mt-n7 text-end">
                                    <v-btn @click="search_report()" color="indigo" x-small rounded dark>&nbsp;&nbsp;&nbsp;buscar&nbsp;&nbsp;&nbsp;</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-sheet>
                </v-col>  
                <v-col cols="12" md="2"></v-col>  
                </v-row>
                <h5 class="mt-5">DETALLE REPORTE</h5>
                <div v-if="tipo==''">
                    <v-simple-table fixed-header dense height="250" style="border:1px solid lightgray">
                        <thead>
                            <tr>
                                <th style="background-color: lightgrey;">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <td class="text-center"><span class="text-caption">Selecciona Tipo Reporte</span></td>
                        </tbody>
                    </v-simple-table>
                </div>
                <div v-if="tipo=='Venta Servicios'">
                    <v-simple-table fixed-header dense height="250" style="border:1px solid lightgray" class="text-size">
                        <thead>
                            <tr>
                                <th style="background-color: lightgrey;">N° Atención</th>
                                <th style="background-color: lightgrey;">Fecha</th>
                                <th style="background-color: lightgrey;">Profesional</th>
                                <th style="background-color: lightgrey;">Servicio / Detalle</th>
                                <th style="background-color: lightgrey;">Produccion</th>
                                <th style="background-color: lightgrey;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in myProceso" :key="item.ID">
                                <td><span>{{ item.ID }}</span></td>
                                <td><span>{{ item.Fecha }}</span></td>
                                <td><span>{{ item.Profesional }}</span></td>
                                <td><span>{{ item.Servicio }} / {{ item.Detalle }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Total_Servicio)) }}</span></td>
                                <td class="text-center"><v-btn small icon><v-icon small color="grey">not_interested</v-icon></v-btn></td>

                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <div v-if="tipo=='Venta Productos'">
                    <v-simple-table fixed-header dense height="250" style="border:1px solid lightgray" class="text-size">
                        <thead>
                            <tr>
                                <th style="background-color: lightgrey;">N° Venta</th>
                                <th style="background-color: lightgrey;">Sku / Producto</th>
                                <th style="background-color: lightgrey;">Precio</th>
                                <th style="background-color: lightgrey;">Cantidad</th>
                                <th style="background-color: lightgrey;">Total</th>
                                <th style="background-color: lightgrey;">Vendedor</th>
                                <th style="background-color: lightgrey;">Ver</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in myVentas" :key="item.ID">
                                <td><span>{{ item.Folio }}</span></td>
                                <td><span>{{ item.Sku }} / {{ item.Producto }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Precio)) }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Cantidad)) }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Total)) }}</span></td>
                                <td><span>{{ item.Usuario }}</span></td>
                                <td class="text-center"><v-btn @click="PDF_venta(item)" small icon><v-icon small color="indigo">visibility</v-icon></v-btn></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <div v-if="tipo=='Liquidaciones'">
                    <v-simple-table fixed-header dense height="250" style="border:1px solid lightgray" class="text-size">
                        <thead>
                            <tr>
                                <th style="background-color: lightgrey;">N° Liquidación</th>
                                <th style="background-color: lightgrey;">Emisión</th>
                                <th style="background-color: lightgrey;">Periodo</th>
                                <th style="background-color: lightgrey;">Profesional</th>
                                <th style="background-color: lightgrey;">Producción</th>
                                <th style="background-color: lightgrey;">Descuento</th>
                                <th style="background-color: lightgrey;">Monto Spa.</th>
                                <th style="background-color: lightgrey;">Monto Pro.</th>
                                <th style="background-color: lightgrey;">Ver</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in myLiquida" :key="item.ID">
                                <td><span>{{ item.ID }}</span></td>
                                <td><span>{{ item.Emision }}</span></td>
                                <td><span>{{ item.Periodo }}</span></td>
                                <td><span>{{ item.Profesional }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Produccion)) }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Descuento)) }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Egreso)) }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Ingreso)) }}</span></td>
                                <td class="text-center"><v-btn @click="PDF_liquida(item)" small icon><v-icon small color="indigo">visibility</v-icon></v-btn></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <div v-if="tipo=='Gastos'">
                    <v-simple-table fixed-header dense height="250" style="border:1px solid lightgray" class="text-size">
                        <thead>
                            <tr>
                                <th style="background-color: lightgrey;">Fecha</th>
                                <th style="background-color: lightgrey;">Servicio</th>
                                <th style="background-color: lightgrey;">Detalle</th>
                                <th style="background-color: lightgrey;">Profesional</th>
                                <th style="background-color: lightgrey;">Monto</th>
                                <th style="background-color: lightgrey;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in myGastos" :key="item.ID">
                                <td><span>{{ item.Fecha }}</span></td>
                                <td><span>{{ item.Servicio }}</span></td>
                                <td><span>{{ item.Detalle }}</span></td>
                                <td><span>{{ item.Profesional }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Monto)) }}</span></td>
                                <td class="text-center"><v-btn small icon><v-icon small color="grey">not_interested</v-icon></v-btn></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <div v-if="tipo=='Cuenta Corriente'">
                    <v-simple-table fixed-header dense height="250" style="border:1px solid lightgray" class="text-size">
                        <thead>
                            <tr>
                                <th style="background-color: lightgrey;">Fecha</th>
                                <th style="background-color: lightgrey;">Solarium</th>
                                <th style="background-color: lightgrey;">Salon</th>
                                <th style="background-color: lightgrey;">Descuentos</th>
                                <th style="background-color: lightgrey;">Gastos</th>
                                <th style="background-color: lightgrey;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in myRinde" :key="item.ID">
                                <td><span>{{ item.Fecha }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Solarium)) }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Salon)) }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Descuentos)) }}</span></td>
                                <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Gastos)) }}</span></td>
                                <td class="text-center"><v-btn small icon><v-icon small color="grey">not_interested</v-icon></v-btn></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <v-row class="mt-n2">
                    <v-col cols="12" class="text-end">
                        <v-btn @click="descargarXLS()" color="teal" small rounded dark>&nbsp;&nbsp;&nbsp;Exportar&nbsp;&nbsp;&nbsp;</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div style="height: 50px;"></div>
        <v-footer fixed color="#005a95" height="50"></v-footer>

        <img id="logo_solarium" src="@/assets/logo-web.png" height="0" width="0">  

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 10pt !important;
    height: 10px !important;
    /* background-color: lightyellow; */
}
</style>
<script>
import axios from "axios";
import { jsPDF } from "jspdf";
import exportXlsFile from 'export-from-json';
import exportFromJSON from 'export-from-json';
export default {
  name: 'Reporte',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    snack:false,
    color_snack:'',
    mensaje:'',
    bloqueo:null,
    loading:false,

    menu1:false,
    date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    menu2:false,
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    tipo:'',
    tipos:[],
    
    myProceso:[],
    myVentas:[],
    myLiquida:[],
    lista:[],
    myEmisor:[],
    myRinde:[],
    myGastos:[],

  }),
  async mounted(){
    const myToken = localStorage.getItem('dops_apiKey');
    const myUser = localStorage.getItem('dops_myuser');
    const myContrato = localStorage.getItem('dops_mycontrato');
    const myTime = localStorage.getItem('dops_timeuser');
    if(myToken!=null && myUser!=null && myContrato!=null){
      //verificamos la expiracion
      const ahora = new Date();
      const expira = new Date(myTime);
      if(ahora > expira){
        this.goLogin()
      } else {
        this.apikey = myToken;
        this.contrato = myContrato;
        this.user = myUser;
        this.loading=true;
        this.bloqueo = await this.myPermiso(10);
        if(parseInt(this.bloqueo)!=0){
            //await this.cuenta_detalle();
            //await this.search_emisor();
        };
        this.loading=false
      }
    } else {
        this.goLogin();
    }
  },
  methods:{
    goLogin(){
        localStorage.removeItem('dops_apiKey');
        localStorage.removeItem('dops_myuser');
        localStorage.removeItem('dops_mycontrato');
        localStorage.removeItem('dops_timeuser');
        this.$router.push({name:'Login'})
    },
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'id' : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async search_emisor(){
        this.myEmisor=[];
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/emisor/',params,{headers});
            const datos = res.data;
            console.log('emisor',datos);
            if(datos[0].existe=='si'){
                var img = document.getElementById("logo_solarium");
                img.src=datos[0].Logo;
                this.myEmisor=datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    change_tipo(){
        this.myProceso=[];
        this.myVentas=[];
        this.myLiquida=[];
        this.myRinde=[];
        this.myGastos=[];
        this.lista=[];
    },
    async search_report(){
        this.loading=true;
        if(this.tipo!=''){
            const key = this.tipo;
            switch (key) {
                case 'Venta Servicios':
                    await this.search_atencion();
                break;
                case 'Venta Productos':
                    await this.search_ventas();
                break;
                case 'Liquidaciones':
                    await this.search_liquida();
                break;
                case 'Gastos':
                    await this.search_gastos();
                break;
                case 'Cuenta Corriente':
                    await this.search_rinde();
                break;
            }
        } else {
            this.color_snack='error';
            this.mensaje='Seleccione tipo de reporte';
            this.snack=true
        }
        this.loading=false;
    },
    async search_atencion(){
        this.myProceso=[];
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'desde' : this.date1,
                'hasta' : this.date2,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/report/atencion/',params,{headers});
            const datos = res.data;
            console.log('atencion',datos);
            if(datos[0].existe=='si'){
                this.myProceso=datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    async search_ventas(){
        this.myVentas=[];
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'desde' : this.date1,
                'hasta' : this.date2,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/report/ventas/',params,{headers});
            const datos = res.data;
            console.log('ventas',datos);
            if(datos[0].existe=='si'){
                this.myVentas=datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    async search_liquida(){
        this.myLiquida=[];
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'desde' : this.date1,
                'hasta' : this.date2,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/report/liquida/',params,{headers});
            const datos = res.data;
            console.log('liquida',datos);
            if(datos[0].existe=='si'){
                this.myLiquida=datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    async PDF_liquida(item){
        this.loading=true;
        const array_PDF = this.myLiquida.filter(res => parseInt(res.ID) == parseInt(item.ID));
        const head_venta = array_PDF[0];
        console.log(head_venta)

        const doc = new jsPDF('p', 'mm', 'letter');

        var img_fondo = document.getElementById("logo_solarium");
        doc.addImage(img_fondo, 'JPEG', 15, 15, 75, 20)

        //grosor linea
        doc.setLineWidth(0.2);
        //horizontal lines
        doc.line(10, 10, 120, 10);
        doc.line(10, 40, 120, 40);
        //vertical lines
        doc.line(10, 9.5, 10, 40.5);
        doc.line(120, 9.5, 120, 40.5);

        doc.setFont("arial", "bold");
        doc.setFontSize(10);
        doc.text('RECIBO DE LIQUIDACIÓN', 145, 15);
        doc.setFont("arial", "NORMAL");
        doc.setFontSize(8);
        doc.text('PERIODO :', 150, 21);
        doc.text('' + head_venta.Periodo, 170, 21);

        doc.line(130, 30, 200, 30);
        doc.line(130, 40, 200, 40);
        //vertical lines
        doc.line(130, 30.5, 130, 40.5);
        doc.line(200, 30.5, 200, 40.5);

        doc.setFont("arial", "bold");
        doc.setFontSize(10);
        doc.text('NÚMERO:', 135, 36);
        doc.setFontSize(12);
        doc.text('' + head_venta.ID, 180, 36);

        doc.line(10, 45, 200, 45);
        doc.line(10, 65, 200, 65);
        //vertical lines
        doc.line(10, 45.5, 10, 65.5);
        doc.line(200, 45.5, 200, 65.5);

        //obtener datos del usuario
        doc.setFontSize(8);
        doc.text('PROFESIONAL', 15, 51);
        doc.text('ID USUARIO', 145, 51);
        doc.text('EMAIL', 15, 56);
        doc.text('USUARIO', 15, 61);
        doc.text('TIPO USUARIO', 80, 61);
        doc.text('COMISIÓN', 145, 61);
        let comision_user = 0;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Token ' + this.apikey
        };
        const params = {
            'contrato' : this.contrato,
            'user' : this.user,
            'usuario' : head_venta.Profesional
        };
        const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/user/',params,{headers});
        const datos = res.data;
        if(datos[0].existe=='si'){
            doc.setFont("arial", "normal");
            doc.text(':  '+ datos[0].nombre, 37, 51);
            doc.text(':  '+ datos[0].ID, 175, 51);
            doc.text(':  '+ datos[0].email, 37, 56);
            doc.text(':  '+ datos[0].usuario, 37, 61);
            doc.text(':  '+ datos[0].tipo, 105, 61);
            doc.text(':  '+ datos[0].comision +'%', 175, 61);
            comision_user=datos[0].comision
        };

        doc.line(10, 70, 200, 70);
        doc.line(10, 75, 200, 75);
        doc.setFont("arial", "bold");
        doc.text('FECHA', 10, 73.5);
        doc.text('DESCRIPCIÓN', 30, 73.5);
        doc.text('PRODUCCIÓN', 150, 73.5, { align: "right" });
        doc.text('DESCUENTO', 180, 73.5, { align: "right" });
        doc.text('TOTAL', 200, 73.5, { align: "right" });
        
        //Detalle
        let suma_total = 0;
        let line = 80;
        doc.setFont("arial", "normal");
        //buscar el detalle de la liquidacion
        const par = {
            'contrato' : this.contrato,
            'user' :  this.user,
            'usuario' :  head_venta.Profesional,
            'mes' :  head_venta.Mes,
            'anio' :  head_venta.Anio,
        };
        const res_liq = await axios.post(process.env.VUE_APP_URL + '/api/v1/filter/liquida/',par,{headers});
        const data_liq = res_liq.data;
        if(data_liq[0].existe=='si'){
            data_liq.forEach(element => {
                doc.text('' + element.Fecha, 10, line);
                doc.text('' + element.Servicio + ' / ' + element.Detalle, 30, line);
                doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Total_Servicio)), 150, line, { align: "right" });
                doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Desc_Tarjeta)), 180, line, { align: "right" });
                doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Ingreso_Profesional)), 200, line, { align: "right" });                            
                suma_total = parseFloat(suma_total) + parseFloat(element.Ingreso_Profesional);
                line = line + 5;
            });
        };
        //buscar el ventas de la liquidacion
        const parametros = {
            'contrato' : this.contrato,
            'user' :  this.user,
            'usuario' :  head_venta.Profesional,
            'desde' :  head_venta.Desde,
            'hasta' :  head_venta.Hasta,
        };
        const res_venta = await axios.post(process.env.VUE_APP_URL + '/api/v1/filter/ventas/',parametros,{headers});
        const data_venta = res_venta.data;
        console.log('data_venta',data_venta)
        if(data_venta[0].existe=='si'){
            data_venta.forEach(element => {
                const comision_venta = parseFloat(parseFloat(element.Total) * (parseFloat(comision_user)/100)).toFixed(0);
                doc.text('' + element.Fecha, 10, line);
                doc.text('' + element.Sku + ' / ' + element.Producto, 30, line);
                doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Total)), 150, line, { align: "right" });
                doc.text('' + '0', 180, line, { align: "right" });
                doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(comision_venta)), 200, line, { align: "right" });                            
                suma_total = parseFloat(suma_total) + parseFloat(comision_venta);
                line = line + 5;
            });
        }                
        //buscar los anticipos de la liquidacion
        const par_anticipo = {
            'contrato' : this.contrato,
            'user' :  this.user,
            'usuario' :  head_venta.Profesional,
            'mes' :  head_venta.Mes,
            'anio' :  head_venta.Anio,
        };
        const res_anticipo = await axios.post(process.env.VUE_APP_URL + '/api/v1/filter/anticipos/',par_anticipo,{headers});
        const data_anticipo = res_anticipo.data;
        console.log('data_anticipo',data_anticipo)
        if(data_anticipo[0].existe=='si'){
            data_anticipo.forEach(element => {
                doc.text('' + element.Fecha, 10, line);
                doc.text('' + element.Servicio + ' / ' + element.Detalle, 30, line);
                doc.text('0', 150, line, { align: "right" });
                doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Monto)), 180, line, { align: "right" });
                doc.text('-' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Monto)), 200, line, { align: "right" });                            
                suma_total = parseFloat(suma_total) - parseFloat(element.Monto);
                line = line + 5;
            });
        }                

        doc.line(10, 225, 200, 225);

        //Total
        doc.line(130, 230, 200, 230);
        doc.line(130, 240, 200, 240);
        //vertical lines
        doc.line(130, 230, 130, 240);
        doc.line(200, 230, 200, 240);

        doc.setFont("arial", "bold");
        doc.setFontSize(10);
        doc.text('TOTAL', 135, 236);
        doc.setFontSize(12);
        doc.text('$' + new Intl.NumberFormat("de-DE").format(parseFloat(suma_total)), 180, 236);

        //Recibi conforme
        doc.setFont("arial", "normal");
        doc.setFontSize(8);
        doc.line(20, 260, 70, 260);
        doc.text('Recibí Conforme', 35, 265);

        doc.line(140, 260, 190, 260);
        doc.text('Solarium Spa', 160, 265);

        
        doc.output('dataurlnewwindow');
        this.loading=false;
    },
    async PDF_venta(item){
        this.loading=true;
        const array_PDF = this.myVentas.filter(res => parseInt(res.Folio) == parseInt(item.Folio));
        const head_venta = array_PDF[0];
        const doc = new jsPDF('p', 'mm', 'letter');

        var img_fondo = document.getElementById("logo_solarium");
        doc.addImage(img_fondo, 'JPEG', 15, 15, 75, 20)

        //grosor linea
        doc.setLineWidth(0.2);
        //horizontal lines
        doc.line(10, 10, 120, 10);
        doc.line(10, 40, 120, 40);
        //vertical lines
        doc.line(10, 9.5, 10, 40.5);
        doc.line(120, 9.5, 120, 40.5);

        doc.setFont("arial", "bold");
        doc.setFontSize(10);
        doc.text('COMPROBANTE DE VENTA', 145, 15);
        doc.setFont("arial", "NORMAL");
        doc.setFontSize(8);
        doc.text('FECHA:', 150, 21);
        doc.text('' + head_venta.Fecha, 170, 21);

        doc.line(130, 30, 200, 30);
        doc.line(130, 40, 200, 40);
        //vertical lines
        doc.line(130, 30.5, 130, 40.5);
        doc.line(200, 30.5, 200, 40.5);

        doc.setFont("arial", "bold");
        doc.setFontSize(10);
        doc.text('NÚMERO:', 135, 36);
        doc.setFontSize(12);
        doc.text('' + head_venta.Folio, 180, 36);

        doc.line(10, 45, 200, 45);
        doc.line(10, 65, 200, 65);
        //vertical lines
        doc.line(10, 45.5, 10, 65.5);
        doc.line(200, 45.5, 200, 65.5);

        doc.setFontSize(8);
        doc.text('CLIENTE', 15, 51);
        doc.text('RUT', 145, 51);
        doc.text('EMAIL', 15, 56);
        doc.text('TELEFONO', 145, 56);
        doc.text('DIRECCIÓN', 15, 61);

        //buscar datos del cliente
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Token ' + this.apikey
        };
        const params = {
            'contrato' : this.contrato,
            'user' : this.user,
            'clients' : head_venta.Rut
        };
        const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/clients/',params,{headers});
        const datos = res.data;
        if(datos[0].existe=='si'){
            doc.setFont("arial", "normal");
            doc.text(':  '+ datos[0].Cliente, 37, 51);
            doc.text(':  '+ datos[0].Rut, 175, 51);
            doc.text(':  '+ datos[0].Email, 37, 56);
            doc.text(':  '+ datos[0].Telefono, 175, 56);
            doc.text(':  '+ datos[0].Direccion, 37, 61);
        };
        doc.line(10, 70, 200, 70);
        doc.line(10, 75, 200, 75);
        doc.setFont("arial", "bold");
        doc.text('SKU', 10, 73.5);
        doc.text('PRODUCTO', 30, 73.5);
        doc.text('PRECIO', 150, 73.5, { align: "right" });
        doc.text('CANTIDAD', 180, 73.5, { align: "right" });
        doc.text('TOTAL', 200, 73.5, { align: "right" });
        
        //Detalle
        let suma_total = 0;
        let line = 80;
        doc.setFont("arial", "normal");
        array_PDF.forEach(element => {
            doc.text('' + element.Sku, 10, line);
            doc.text('' + element.Producto, 30, line);
            doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)), 150, line, { align: "right" });
            doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Cantidad)), 180, line, { align: "right" });
            doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Total)), 200, line, { align: "right" });
            suma_total = parseFloat(suma_total) + parseFloat(element.Total);
            line = line + 5;
        });

        doc.line(10, 225, 200, 225);

        //Total
        doc.line(130, 230, 200, 230);
        doc.line(130, 252, 200, 252);
        //vertical lines
        doc.line(130, 230, 130, 252);
        doc.line(200, 230, 200, 252);

        doc.setFont("arial", "bold");
        doc.setFontSize(10);
        doc.text('NETO', 135, 236);
        doc.text('IVA', 135, 242);
        doc.text('TOTAL', 135, 248);

        doc.setFontSize(12);
        const neto = parseFloat(parseFloat(suma_total) / 1.19).toFixed(0);
        const iva = parseFloat(suma_total) - parseFloat(neto);
        doc.text('$' + new Intl.NumberFormat("de-DE").format(parseFloat(neto)), 198, 236, { align: "right" });
        doc.text('$' + new Intl.NumberFormat("de-DE").format(parseFloat(iva)), 198, 242, { align: "right" });
        doc.text('$' + new Intl.NumberFormat("de-DE").format(parseFloat(suma_total)), 198, 248, { align: "right" });


        
        doc.output('dataurlnewwindow')
        this.loading=false;

    },
    descargarXLS(){
      this.loading=true;
      if(this.tipo!=''){
        let result = [];
        const key = this.tipo;
        switch (key) {
            case 'Venta Servicios':
                result = this.myProceso;
            break;
            case 'Venta Productos':
                result = this.myVentas;
            break;
            case 'Liquidaciones':
                result = this.myLiquida;
            break;
        };
        if(result.length!=0){
            //este modulo descarga el array del reporte
            let tbl_data = result;
            let name_file = this.tipo + '_' + this.date1 + '_' + this.date2;
            const data = tbl_data;
            const fileName = name_file;
            const exportType = exportFromJSON.types.xls;
            exportXlsFile({ data, fileName, exportType })
        } else {
            this.color_snack='error';
            this.mensaje='No hay datos en la lista';
            this.snack=true
        }
      } else {
        this.color_snack='error';
        this.mensaje='Seleccione tipo reporte';
        this.snack=true
      }
      this.loading=false;
    },
    async search_gastos(){
        this.myGastos=[];
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'desde' : this.date1,
                'hasta' : this.date2,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/report/gastos/',params,{headers});
            const datos = res.data;
            console.log('gastos',datos);
            if(datos[0].existe=='si'){
                this.myGastos=datos;
            }
        } catch (error) {
            console.log(error)
        }

    },
    async search_rinde(){
        this.myRinde=[];
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + this.apikey
            };
            const params = {
                'contrato' : this.contrato,
                'user' : this.user,
                'desde' : this.date1,
                'hasta' : this.date2,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/report/rinde/',params,{headers});
            const datos = res.data;
            console.log('rinde',datos);
            if(datos[0].existe=='si'){
                this.myRinde=datos;
            }
        } catch (error) {
            console.log(error)
        }
    }






  }
}
</script>
